import React from 'react';

interface Props {
  children: React.ReactNode;
  fallback?: React.ReactNode;
  onError?: (subject: string, error: Error, errorInfo: React.ErrorInfo) => void;
  subject: string;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  componentDidCatch(_error: Error, _errorInfo: React.ErrorInfo) {}

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? <span data-testid="No-fallback-provided"></span>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
